import { render, staticRenderFns } from "./MyCollect.vue?vue&type=template&id=20aefee8&scoped=true&"
import script from "./MyCollect.vue?vue&type=script&lang=js&"
export * from "./MyCollect.vue?vue&type=script&lang=js&"
import style0 from "./MyCollect.vue?vue&type=style&index=0&lang=less&"
import style1 from "./MyCollect.vue?vue&type=style&index=1&id=20aefee8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aefee8",
  null
  
)

export default component.exports